export const T = {
  en_GB: {
    addProduct: "Add Product",
    amount: "Amount",
    numberOfUnits: "Number of units",
    estimatedFromUnits: "Amount is estimated from units × last price (in the flow currency).",
    units: "Units",
    product: "Product",
    isinLabel: "ISIN:",
    cancel: "Cancel",
    save: "Save",
    editProductAmount: "Edit Product Amount",
    searchAndFilterDescription:
      "Search and filter products, then select one to add to your portfolio.",
    updateAmountDescription: "Update the amount allocated to this product.",
    currentTotal: "Current total:",
    newTotal: "New total:",
    minBuyDialogHint: (min: string) => `Minimum buy for this product: ${min}`,
    minBuyDialogError: (min: string) => `Amount is below the minimum buy of ${min}`,
    currentValue: "Current Value",
    change: "Change",
    notAvailableForPurchase:
      "This product is not available for new purchases. You can keep or reduce the current holding.",
    // Review #3 — neutral on purpose: this also fires for an agreement
    // follow-up's currently funded savings-plan line, where "nothing of it
    // is held yet" would be a materially wrong claim about money the client
    // has actually invested.
    lockedRemoveOnly:
      "This product can no longer be purchased in this flow. It can only be removed from the portfolio.",
    keep: "Keep",
    sell: "Sell",
    sellAmountLabel: "Sell amount",
    // Instruction editing of held followup instruments (Sell | Keep | Buy)
    buy: "Buy",
    buyAmountLabel: "Buy amount",
    buyUnitsLabel: "Units to buy",
    sellUnitsLabel: "Units to sell",
    newHoldingLabel: "New holding",
    deltaSellTooMuch: (max: string) => `You can sell at most ${max}.`,
    // QL-398 — min buy on an account follow-up is judged per transaction: the
    // top-up itself (never the holding), and each switch pair on its own.
    minBuyTopupHint: (min: string) => `A purchase must be at least ${min}.`,
    minBuyTopupError: (buy: string, min: string) =>
      `The purchase of ${buy} is below the minimum buy of ${min}.`,
    sellAllShortcut: "Sell all",
  },
  nb_NO: {
    addProduct: "Legg til produkt",
    amount: "Beløp",
    numberOfUnits: "Antall andeler",
    estimatedFromUnits: "Beløpet er estimert fra andeler × sist pris (i flytvaluta).",
    units: "Andeler",
    product: "Produkt",
    isinLabel: "ISIN:",
    cancel: "Avbryt",
    save: "Lagre",
    editProductAmount: "Rediger produktbeløp",
    searchAndFilterDescription:
      "Søk og filtrer produkter, velg deretter et produkt å legge til i porteføljen.",
    updateAmountDescription: "Oppdater beløpet som er tildelt dette produktet.",
    currentTotal: "Nåværende total:",
    newTotal: "Ny total:",
    minBuyDialogHint: (min: string) => `Minimumskjøp for dette produktet: ${min}`,
    minBuyDialogError: (min: string) => `Beløpet er under minimumskjøpet på ${min}`,
    currentValue: "Nåværende verdi",
    change: "Endring",
    notAvailableForPurchase:
      "Dette produktet er ikke tilgjengelig for nye kjøp. Du kan beholde eller redusere gjeldende beholdning.",
    lockedRemoveOnly:
      "Dette produktet kan ikke lenger kjøpes i denne flyten. Det kan bare fjernes fra porteføljen.",
    keep: "Behold",
    sell: "Selg",
    sellAmountLabel: "Salgsbeløp",
    // Instruksjonsredigering av eksisterende beholdninger (Selg | Behold | Kjøp)
    buy: "Kjøp",
    buyAmountLabel: "Kjøpsbeløp",
    buyUnitsLabel: "Antall andeler å kjøpe",
    sellUnitsLabel: "Antall andeler å selge",
    newHoldingLabel: "Ny beholdning",
    deltaSellTooMuch: (max: string) => `Du kan selge maksimalt ${max}.`,
    minBuyTopupHint: (min: string) => `Et kjøp må være minst ${min}.`,
    minBuyTopupError: (buy: string, min: string) =>
      `Kjøpet på ${buy} er under minstekjøpet på ${min}.`,
    sellAllShortcut: "Selg alt",
  },
} as const;
